import { useEffect } from 'react';

const SITE = 'https://sudcosolutions.com';

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

// Sets per-page title, description, canonical, and OG/Twitter overrides for
// client-side routes. `path` should start with "/" — the canonical is always
// the production URL so localhost dev never emits a bad canonical.
export default function useSeo({ title, description, path, image }) {
  useEffect(() => {
    const url = `${SITE}${path || '/'}`;
    const img = image ? `${SITE}${image}` : `${SITE}/images/og-card.png`;

    if (title) {
      document.title = title;
      upsertMeta('property', 'og:title', title);
      upsertMeta('name', 'twitter:title', title);
    }
    if (description) {
      upsertMeta('name', 'description', description);
      upsertMeta('property', 'og:description', description);
      upsertMeta('name', 'twitter:description', description);
    }
    upsertCanonical(url);
    upsertMeta('property', 'og:url', url);
    upsertMeta('property', 'og:image', img);
    upsertMeta('name', 'twitter:image', img);
  }, [title, description, path, image]);
}
